import React from 'react'
import { motion } from 'framer-motion'

function AnimatePage({ children }) {
    return (
        <motion.div className='w-full relative' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
            {children}
        </motion.div>
    )
}

export default AnimatePage